import {
  LocalShippingOutlined,
  EventNoteOutlined,
  MapRounded,
  Assessment,
  Hub,
  Person,
  Warehouse,
  FilterList,
  LinkOutlined,
  AddTask,
  Group,
  Tune,
  Paid,
  Wallet,
  Inventory,
  ViewInAr,
  LocalShipping,
  ManageAccounts,
  Calculate,
  Gavel,
  CreditCard,
  Category,
  WhatsApp,
  LocationOn,
  ShoppingBagOutlined,
} from "@mui/icons-material";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
export const MERCHANT_TABS = (successOrdersCount, faildOrdersCout) => [
  {
    href: "/merchant",
    icon: Assessment,
    title: "Statistics",
  },
  {
    href: "/merchant/tasks/create",
    icon: AddTask,
    title: "Create task",
  },
  {
    href: "/merchant/all-tasks/zone?status=TASK_ASSIGNED_TO_DRIVER_FOR_DROP_OFF",
    icon: EventNoteOutlined,
    title: "Tasks",
  },
  {
    href: "/merchant/all-orders/zone?status=UNASSIGNED&type=PICK_UP",
    icon: EventNoteOutlined,
    title: "Orders",
  },
  {
    icon: FilterList,
    title: "Filter",
    children: [
      {
        href: "/merchant/orders/filter",
        icon: FilterList,
        title: "filterOrders",
      },
      {
        href: "/merchant/tasks/filter",
        icon: FilterList,
        title: "Tasks filter",
      },
    ],
  },
  {
    icon: LocalShipping,
    title: "Mapit Ship",
    id: "mapitShip-btn",
    children: [
      {
        href: "/merchant/mapit-ship/shipments?status=ORDER_PENDING",
        icon: Inventory,
        title: "Shipments",
        id: "shipment-btn",
      },
      {
        href: "/merchant/mapit-ship/products",
        icon: AddShoppingCartIcon,
        title: "Products",
      },
      {
        href: "/merchant/mapit-ship/boxes",
        icon: ViewInAr,
        title: "Boxes",
      },
      {
        href: "/merchant/cod-invoices",
        icon: Paid,
        title: "COD Wallet",
      },
      {
        href: "/merchant/mapit-ship/price-calculator",
        icon: Calculate,
        title: "Price Calculator",
        id: "price-calculator-btn",
      },
      {
        href: "/merchant/mapit-ship/aramex-satchels?status=ORDER_ASSIGNED_TO_SHIPPING_COMPANY",
        icon: ShoppingBagOutlined,
        title: "Aramex Satchels",
      },
    ],
  },
  {
    href: "/merchant/warehouse",
    icon: Warehouse,
    title: "Warehouses",
    id: "warehouse-sidebar",
  },
  {
    href: "/merchant/connections",
    icon: Hub,
    title: "Private connections",
  },
  {
    href: "/merchant/drivers",
    icon: LocalShippingOutlined,
    title: "Drivers",
  },
  {
    href: "/merchant/users",
    icon: Group,
    title: "Users",
  },
  {
    href: "/merchant/integrations",
    icon: LinkOutlined,
    title: "Integrations",
  },
  {
    href: "/merchant/zones",
    icon: MapRounded,
    title: "Zones",
  },

  {
    icon: Person,
    title: "Account",
    children: [
      {
        href: "/merchant/account/plans",
        icon: Category,
        title: "Plans",
      },
      {
        href: "/merchant/account/subscription",
        icon: CreditCard,
        title: "Subscription",
      },
      {
        href: "/merchant/account/settings",
        icon: ManageAccounts,
        title: "Settings",
      },
    ],
  },
  {
    href: "/merchant/customizations",
    icon: Tune,
    title: "Customizations",
  },
  {
    href: "/merchant/transactions",
    icon: Paid,
    title: "Transactions",
  },
  {
    href: "/merchant/balance",
    icon: Wallet,
    title: "Wallet Balance",
  },
  {
    icon: WhatsApp,
    title: "Whatsapp Msgs",
    href: "/merchant/settings/whatsapp",
  },
  {
    href: "/terms-and-conditions",
    icon: Gavel,
    title: "Terms and Conditions",
  },
  {
    href: "/merchant/national-address-transactions",
    icon: LocationOn,
    title: "National Address Requests",
  },
];
